export const config = {
  efArray: {
    token: 'f89f6901fb00093d129873fb3b9a55f2849a88b3',
    useTrainingArrayId: true,
    trainingIdFieldName: 'idFormationBitrix',
    mockPathName: 'inscription-anglais',
    domainId: 0,
  },
  gtm: {
    domain: 'https://www.googletagmanager.com',
    dataLayerName: 'dataLayer',
    id: import.meta.env.VITE_DATALAYER_ID as string,
  },
  apiUrl: {
    leadFlow: import.meta.env.VITE_API_LEAD_FLOW_PATH as string,
  },
  cloudFunctionUrl: {
    formLeadNew: import.meta.env.VITE_API_FORM_LEAD_NEW as string,
  },
  gcp: {
    cloudStorage: {
      formLeadIconUrl: 'https://storage.googleapis.com/form_lead/icons/',
    },
  },
};
